const actions = {
    SET_CATEGORY: 'SET_CATEGORY',
    SET_PRODUCTS: 'SET_PRODUCTS',
    SET_LOADER: 'SET_LOADER',
    RESET_CATEGORIES: 'RESET_CATEGORIES',
  }
  
  export default actions;
  